import axios from 'axios';

//Apontamento da API de acordo com o ambiente
let baseURL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8090/';

export default axios.create({
    baseURL,
    headers: {
        'x-origin-application': 'portal-co-digital',
        'x-origin-channel': 'web',
        'x-version': process.env.REACT_APP_VERSION
    }
});
